import { render, staticRenderFns } from "./ImageField.vue?vue&type=template&id=06a8b2d2"
import script from "./ImageField.vue?vue&type=script&lang=js"
export * from "./ImageField.vue?vue&type=script&lang=js"
import style0 from "./ImageField.vue?vue&type=style&index=0&id=06a8b2d2&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports